module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_3009.f443bdd5.png";